module.exports = __webpack_public_path__ + "media/images/application/icons/icon-arrow-articles-33edfd27044adebf72deb712d6634a39.svg";